import Page from 'modules/DnaResults'

export default Page

